import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenshotSection } from './ScreenshotSection';
import { uiLocale } from '../../../i18n/language';
import { localizePageName } from '../../../utils/metadataGenerator';

interface MetadataContentProps {
  getCurrentPageName: () => string;
  screenshot: string | null;
  screenshotError: string | null;
  isCapturingScreenshot: boolean;
  onFileUpload: (file: File) => void;
  gaSessionId: string | null;
  gaClientId: string | null;
  sessionId?: string;
  getRolePlaySettingsMetadata: () => Record<string, any> | null;
  rolePlayData: any;
}

export const MetadataContent: React.FC<MetadataContentProps> = ({
  getCurrentPageName,
  screenshot,
  screenshotError,
  isCapturingScreenshot,
  onFileUpload,
  sessionId,
  getRolePlaySettingsMetadata,
  rolePlayData
}) => {
  const { t } = useTranslation();
  return (
    <div className="metadata-content">
      <div className="metadata-item">
        <span className="metadata-label">{t('appFeedback.currentPage')}</span>
        <span className="metadata-value">{localizePageName(getCurrentPageName(), t)}</span>
      </div>
      <div className="metadata-item">
        <span className="metadata-label">{t('appFeedback.timestamp')}</span>
        <span className="metadata-value">{new Date().toLocaleString(uiLocale())}</span>
      </div>

      <ScreenshotSection
        screenshot={screenshot}
        screenshotError={screenshotError}
        isCapturingScreenshot={isCapturingScreenshot}
        onFileUpload={onFileUpload}
      />

      {sessionId && (
        <div className="metadata-item">
          <span className="metadata-label">{t('appFeedback.sessionId')}</span>
          <span className="metadata-value">{sessionId}</span>
        </div>
      )}

    </div>
  );
};